import {Component} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {EventsEmitterService} from '../services/emitter.service';
import {LogService} from '../services/log.service';

@Component({
  selector: 'breadcrumbs',
  template: `
    <ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs" let-last="last">
      <li
        style="vertical-align: middle;"
        class="breadcrumb-item"
        *ngIf="
          (breadcrumb.label &&
            breadcrumb.url.substring(breadcrumb.url.length - 1) == '/') ||
          (breadcrumb.label && last)
        "
        [ngClass]="{ active: last }"
      >
        <a *ngIf="!last" [routerLink]="breadcrumb.url">{{
          breadcrumb.label
        }}</a>
        <span *ngIf="last" class="text-md-lg text-sm-md text-sm">{{
          breadcrumb.label
        }}</span>
      </li>
    </ng-template>
  `,
})
export class BreadcrumbsComponent {
  breadcrumbs: Array<Object>;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private logger: LogService,
    private eventsEmitterService: EventsEmitterService,
  ) {}

  private initBreadcrumbs() {
    this.breadcrumbs = [];
    let currentRoute = this.route.root,
      url = '';

    //this.logger.log("Breadcrubs current root: " + this.router.routerState);
    do {
      let childrenRoutes = currentRoute.children;
      currentRoute = null;
      childrenRoutes.forEach((route) => {
        if (route.outlet === 'primary') {
          let routeSnapshot = route.snapshot;
          url += '/' + routeSnapshot.url.map((segment) => segment.path).join('/');

          this.breadcrumbs.push({
            label: route.snapshot.data['lang' + localStorage.getItem('langId')],
            url: url,
          });
          currentRoute = route;
        }
      });
    } while (currentRoute);
  }
  ngOnInit(): void {
    this.initBreadcrumbs();
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.initBreadcrumbs();
      },
    });

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe({
      next: (event) => {
        this.initBreadcrumbs();
      },
    });
  }
}
